<template>
  <div id="vpaCalculator">
    <div class="orbitist-modal show">
      <div class="orbitist-modal-container">
        <button @click="closeModal()" class="btn btn-sm btn-outline-dark rounded-pill float-right"><i class="fas fa-times"></i> Close</button>
        <h3><i class="fas fa-calculator"></i> Vines/acre calculator</h3>

        <form @submit.prevent>

          <div class="slider-field mt-1">
            <label>How spaced out are your rows?</label>
            <div class="row">
              <div class="col-8">
                <!-- ZONE INPUTS -->
                <vue-slider class="mt-1" v-model.number="rowSpacing" :tooltip="false" :min="2" :max="14"></vue-slider>
              </div><!-- /.col-8 -->
              <div class="col-4">
                <input v-model.number="rowSpacing" type="number" class="form-control" /><span class="units">ft</span>
              </div><!-- /.col-4 -->
            </div><!-- /.row -->
          </div><!-- /.slider-field -->

          <div class="slider-field mt-1">
            <label>How spaced out are your vines?</label>
            <div class="row">
              <div class="col-8">
                <!-- ZONE INPUTS -->
                <vue-slider class="mt-1" v-model.number="vineSpacing" :tooltip="false" :min="2" :max="14"></vue-slider>
              </div><!-- /.col-8 -->
              <div class="col-4">
                <input v-model.number="vineSpacing" type="number" class="form-control" /><span class="units">ft</span>
              </div><!-- /.col-4 -->
            </div><!-- /.row -->
          </div><!-- /.slider-field -->

        </form>

        <label>Then you have:</label><br>
        <div class="figure">
          <animated-number :class="'figure-number'" :value="calcVpa()" :formatValue="formatRound" :duration="300" />
          <span class="figure-unit">Vines per acre</span>
        </div><!-- /.figure --><br>

        <button @click="useValue()" class="btn btn-sm btn-outline-dark rounded-pill">Use Value <i class="far fa-arrow-alt-circle-right"></i></button>

      </div><!-- /.orbitist-modal-container -->
    </div><!-- /.orbitist-modal -->
  </div><!-- /#vpaCalculator -->
</template>

<script>
import vueSlider from 'vue-slider-component'
import AnimatedNumber from 'animated-number-vue'

export default {
  components: {
    vueSlider,
    AnimatedNumber
  },
  data() {
    return {
      rowSpacing: 8,
      vineSpacing: 8,
      vpa: 681
    }
  },
  methods: {
    useValue() {
      this.$emit('useValue', this.vpa)
      this.closeModal()
    },
    formatRound(value) {
      return value.toFixed(0);
    },
    calcVpa() {
      let c = 43560
      let g = this.vineSpacing
      let b = this.rowSpacing
      let calc = c / (g * b)
      this.vpa = calc.toFixed(0)
      return calc
    },
    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VpaCalculator.vue